<template>
  <div class="section-box" v-loading="loading">
    <div class="title-box">
      <div class="detail-title">课程详情</div>
      <div class="save-box">
        <el-button
          type="primary"
          plain
          class="publish"
          v-if="fromType == 1 || fromType == 3"
          @click="submitForm(1)"
        >
          保存并发布</el-button
        >
        <el-button
          type="primary"
          plain
          class="publish"
          v-if="fromType == 0"
          @click="pubishFuc(0)"
          >取消发布</el-button
        >
        <el-button
          type="primary"
          class="save"
          v-if="fromType == 0 || fromType == 1 || fromType == 3"
          @click="submitForm(0)"
          >保存</el-button
        >
        <el-button
          type="danger"
          class="save"
          v-if="fromType == 0"
          @click="deleteCourse(0)"
          >删除</el-button
        >
        <el-button
          type="success"
          class="save"
          v-if="fromType == 2"
          @click="deleteCourse(1)"
          >恢复</el-button
        >
      </div>
    </div>
    <el-row class="commonTitle"> 申请信息 </el-row>
    <div>
      <el-form
        :inline="true"
        ref="ruleForm"
        label-width="140px"
        label-position="left"
        :rules="rules"
        :model="form"
        class="one-ruleForm"
      >
        <el-form-item label="课程名称：" prop="courseName">
          <el-input
            size="medium"
            v-model="form.courseName"
            placeholder="请输入课程名称"
            maxlength="100"
            style="width: 550px; margin-right: 80px"
          ></el-input>
        </el-form-item>
        <el-form-item label="领域：" prop="area">
          <el-select
            size="medium"
            v-model="form.area"
            filterable
            placeholder="请选择领域"
            style="width: 550px; margin-right: 80px"
            @change="getProductAndList(form.area, 'mainForm')"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.domainid"
              :label="item.domainname"
              v-for="(item, index) in dominArr"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程类别" prop="paperName">
          <el-select
            size="medium"
            v-model="form.paperName"
            filterable
            placeholder="请选择课程类别"
            style="width: 550px; margin-right: 80px"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.key"
              :label="item.value"
              v-for="(item, index) in courseTypeArr"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品：" prop="product">
          <el-select
            size="medium"
            v-model="form.product"
            filterable
            placeholder="请选择产品"
            style="width: 550px; margin-right: 80px"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.key"
              :label="item.value"
              v-for="(item, index) in productSelectArr"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="难度：" prop="level">
          <el-select
            size="medium"
            v-model="form.level"
            filterable
            placeholder="请选择难度"
            style="width: 550px; margin-right: 80px"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.key"
              :label="item.value"
              v-for="(item, index) in difficultyLevelArr"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌：" prop="brand">
          <el-select
            size="medium"
            v-model="form.brand"
            filterable
            placeholder="请选择品牌"
            style="width: 550px; margin-right: 80px"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.key"
              :label="item.value"
              v-for="(item, index) in brandArr"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="认证情况：" prop="certificate">
          <el-select
            size="medium"
            v-model="form.certificate"
            filterable
            placeholder="请选择认证情况"
            style="width: 550px; margin-right: 80px"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.key"
              :label="item.value"
              v-for="(item, index) in authenticationArr"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业：" prop="industry">
          <el-select
            size="medium"
            v-model="form.industry"
            filterable
            placeholder="请选择行业"
            style="width: 550px; margin-right: 80px"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.industryid"
              :label="item.industryname"
              v-for="(item, index) in industryArr"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收费条件：" prop="priceRequire">
          <el-select
            size="medium"
            v-model="form.priceRequire"
            filterable
            placeholder="请选择收费条件"
            style="width: 550px; margin-right: 80px"
          >
            <el-option value="" label="请选择"></el-option>
            <el-option
              :value="item.key"
              :label="item.value"
              v-for="(item, index) in chargeTypeArr"
              :key="index"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="课程价格：" prop="coursePrice">
          <el-input
            size="medium"
            v-model="form.coursePrice"
            placeholder="请选择课程价格"
            :disabled="isPrice"
            style="width: 550px; margin-right: 80px"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="会员是否免费：" required>
          <el-radio-group v-model="form.nvipIsFree" style="width: 550px; margin-right: 80px">
              <el-radio :label="0">不免费</el-radio>
              <el-radio :label="1">免费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否置顶：" v-if="form.paperName == 1 || form.paperName == 3 || form.paperName == '品牌课程' || form.paperName == '产品培训' ">
          <el-radio-group v-model="form.nisTop">
              <el-radio :label="0">不置顶</el-radio>
              <el-radio :label="1">置顶</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
    </div>
    <el-row class="commonTitle commonTitleIcon"> 关联课程素材 </el-row>
    <div class="tableBox">
      <el-table border :data="listMedia" style="width: 100%">
        <el-table-column label="素材编号" prop="smediaNo" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.smediaNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="素材名称" prop="smediaName" width="600">
          <template slot-scope="scope">
            <span>{{ scope.row.smediaName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="素材类别" prop="smediaType">
          <template slot-scope="scope">
            <span>{{ scope.row.smediaType || "--" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleDown(scope.$index, listMedia, 'course')"
              v-if="scope.$index != listMedia.length - 1"
              >下移</el-button
            >
            <el-button
              size="mini"
              v-if="scope.$index != 0"
              @click="handleUp(scope.$index, listMedia, 'course')"
              >上移
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteCourseItem(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="addCourse" @click="addCourseBtn">添加课程素材</div>
    </div>

    <el-row class="commonTitle"> 关联考试 </el-row>
    <div class="tableBox">
      <el-table border :data="listPaper" style="width: 100%">
        <el-table-column label="考试编号" prop="paperNo" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.spaperNo || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试名称" prop="paperName" width="600">
          <template slot-scope="scope">
            <span>{{ scope.row.spaperName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="考试分类" prop="paperType">
          <template slot-scope="scope">
            <span>{{
              scope.row.npaperAttribute == 1 ? "认证考试" : "课程考试"
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.$index != listPaper.length - 1"
              @click="handleDown(scope.$index, listPaper, 'test')"
              >下移</el-button
            >
            <el-button
              size="mini"
              v-if="scope.$index != 0"
              @click="handleUp(scope.$index, listPaper, 'test')"
              >上移
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteTest(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="addCourse" @click="addTestBtn()">添加考试</div>
    </div>

    <el-row class="commonTitle"> 关联国家认证 </el-row>
    <div class="tableBox">
      <el-table border :data="listCpimtroes" style="width: 100%">
        <el-table-column label="证书号" prop="paperNo" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.id || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="认证名称" prop="paperName" width="600">
          <template slot-scope="scope">
            <span>{{ scope.row.authname || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="领域" prop="paperType">
          <template slot-scope="scope">
            <span>{{ scope.row.domainName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="产品" prop="paperType">
          <template slot-scope="scope">
            <span>{{ scope.row.productName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-if="scope.$index != listCpimtroes.length - 1"
              @click="handleDown(scope.$index, listCpimtroes, 'countries')"
              >下移</el-button
            >
            <el-button
              size="mini"
              v-if="scope.$index != 0"
              @click="handleUp(scope.$index, listCpimtroes, 'countries')"
              >上移
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="deleteCountriesItem(scope.$index)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="addCourse" @click="addCountriesBtn()">添加国家认证</div>
    </div>

    <el-row class="commonTitle"> 介绍文案 </el-row>
    <div class="uploadBox">
      <div class="upload1">
        <div class="tit">课程介绍：</div>
        <div>
          <el-input
            type="textarea"
            size="medium"
            :autosize="{ minRows: 2 }"
            maxlength="1000"
            show-word-limit
            v-model.trim="form.sintro"
            placeholder="请输入课程介绍"
            style="width: 600px;"
          >
          </el-input>
        </div>
      </div>
    </div>
    <div class="uploadBox">
      <div class="upload1">
        <div class="tit">封面图：</div>
        <div>
          <el-upload
            class="show"
            :class="{ hide: hideUploadCover }"
            :action="url"
            list-type="picture-card"
            :limit="1"
            :file-list="fileListCover"
            :on-change="dealImgChangeCover"
            :on-remove="handleDealImgRemoveCover"
            :on-success="handleAvatarSuccessCover"
            :on-preview="handlePictureCardPreview"
            accept=".jpg, .jpeg, .png"
            :before-upload="uploadPreview"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <span class="tips">封面大小690*460,格式：gif/png/jpeg</span>
        </div>
      </div>
    </div>
    <div class="detailImg">
      <div class="tit">详情图：</div>
      <div>
        <!-- <el-upload class="show" :class="{ hide: hideUploadDetail }" :action="url" list-type="picture-card" :limit="1"
            :file-list="fileListDetail" :on-change="dealImgChangeDetail" :on-remove="handleDealImgRemoveDetail"
            :on-success="handleAvatarSuccessDetail" :on-preview="handlePictureCardPreview" accept=".jpg, .jpeg, .png">
            <i class="el-icon-plus"></i>
          </el-upload>
          <span class="tips"> </span> -->
        <editor v-model="ruleText" @change="getEditor" ref="weditor"></editor>
      </div>
    </div>

    <el-dialog
      title="选择课程素材"
      :visible.sync="isCoursePop"
      width="1200px"
      :before-close="handleCloseCourse"
      :close-on-click-modal="false"
    >
      <el-table
        border
        ref="courseTable"
        :data="tableData2"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="素材编号">
          <el-table-column width="200">
            <template slot="header" slot-scope="scope">
              <i style="display: none">{{ scope.row }}</i>
              <el-input
                size="mini"
                v-model="course.mediaNo"
                placeholder="输入关键字搜索"
                @input="GetMatterList()"
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.smediaNo || "--" }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="素材名称">
          <el-table-column show-overflow-tooltip>
            <template slot="header" slot-scope="scope">
              <i style="display: none">{{ scope.row }}</i>
              <el-input
                size="mini"
                v-model="course.mediaName"
                placeholder="输入关键字搜索"
                @input="GetMatterList()"
              />
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.smediaName || "--" }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="素材格式">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="course.mediaType"
                placeholder="请选择"
                filterable
                size="mini"
                @change="GetMatterList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="item in mediaFormatArr"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              {{ scope.row.smediaFormat || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="素材类别">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="course.matterType"
                placeholder="请选择"
                filterable
                size="mini"
                @change="GetMatterList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in matterTypeArr"
                  :value="item.key"
                  :label="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.smediaType || "--" }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="领域">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="course.domin"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getProductAndList(course.domin, 'course')"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in dominArr"
                  :value="item.domainid"
                  :label="item.domainname"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.sdomain || "--" }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="产品">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="course.productId"
                placeholder="请选择"
                filterable
                size="mini"
                @change="GetMatterList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in productSelectArr"
                  :value="item.key"
                  :label="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.sproduct || "--" }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="品牌">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="course.brandId"
                placeholder="请选择"
                filterable
                size="mini"
                @change="GetMatterList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in brandArr"
                  :value="item.key"
                  :label="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              <span>{{ scope.row.sbrand || "--" }}</span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="pageLocation">
        <span>已选择{{ seletedCountCourse }}条数据</span>
        <span>
          <el-pagination
            @size-change="coursehandleSizeChange"
            @current-change="coursehandleCurrentChange"
            :current-page="course.pageNum"
            :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="course.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="course.total"
          >
          </el-pagination>
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="coursePushList()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="选择考试"
      :visible.sync="isTestPop"
      width="1200px"
      :before-close="handleCloseTest"
      :close-on-click-modal="false"
    >
      <el-table
        border
        ref="testTable"
        :data="testTable"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChangeTest"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="考试编号">
          <el-table-column width="200">
            <template slot="header" slot-scope="scope">
              <i style="display: none">{{ scope.row }}</i>
              <el-input
                size="mini"
                v-model="test.paperNo"
                placeholder="输入关键字搜索"
                @input="getExamList()"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.spaperNo || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="考试名称">
          <el-table-column show-overflow-tooltip>
            <template slot="header" slot-scope="scope">
              <i style="display: none">{{ scope.row }}</i>
              <el-input
                size="mini"
                v-model="test.name"
                placeholder="输入关键字搜索"
                @input="getExamList()"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.spaperName || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="考试分类">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="test.paperName"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getExamList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="item in courseAttributeArr"
                  :key="item.value"
                  :label="item.value"
                  :value="item.key"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              <span
                v-text="paperAttributeFun(scope.row.npaperAttribute)"
              ></span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="考试类别">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="test.paperCategory"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getExamList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="item in paperCategoryArr"
                  :value="item.key"
                  :label="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              <span v-text="paperCategoryFun(scope.row.npaperCategory)"></span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="领域">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="test.field"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getProductAndList(test.field, 'test')"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in dominArr"
                  :value="item.domainid"
                  :label="item.domainname"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              {{ scope.row.sfield || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="产品">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="test.product"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getExamList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in productSelectArr"
                  :value="item.key"
                  :label="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              {{ scope.row.sproduct || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="品牌">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="test.brand"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getExamList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in brandArr"
                  :value="item.key"
                  :label="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              {{ scope.row.sbrand || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="pageLocation">
        <span>已选择{{ seletedCountTest }}条数据</span>
        <span>
          <el-pagination
            :page-sizes="[10, 20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="testhandleSizeChange"
            @current-change="testhandleCurrentChange"
            :current-page="test.pageNum"
            :total="test.total"
            :page-size="test.pageSize"
          >
          </el-pagination>
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="testPushList()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="选择国家认证"
      :visible.sync="isCountriesPop"
      width="1200px"
      :before-close="handleCloseCountries"
      :close-on-click-modal="false"
    >
      <el-table
        ref="countriesTable"
        :data="countriesTable"
        border
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChangeCountries"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column label="证书号">
          <el-table-column width="200">
            <template slot="header" slot-scope="scope">
              <i style="display: none">{{ scope.row }}</i>
              <el-input
                size="mini"
                v-model="countries.id"
                placeholder="输入关键字搜索"
                @input="getCountriesList()"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.id || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="认证名称">
          <el-table-column show-overflow-tooltip>
            <template slot="header" slot-scope="scope">
              <i style="display: none">{{ scope.row }}</i>
              <el-input
                size="mini"
                v-model="countries.authname"
                placeholder="输入关键字搜索"
                @input="getCountriesList()"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.authname || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="领域">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="countries.domainId"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getProductAndList(countries.domainId, 'countries')"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in dominArr"
                  :value="item.domainid"
                  :label="item.domainname"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              {{ scope.row.domainName || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="产品">
          <el-table-column show-overflow-tooltip>
            <template slot="header">
              <el-select
                v-model="countries.productId"
                placeholder="请选择"
                filterable
                size="mini"
                @change="getCountriesList()"
              >
                <el-option value="" label="请选择"></el-option>
                <el-option
                  v-for="(item, index) in productSelectArr"
                  :value="item.key"
                  :label="item.value"
                  :key="index"
                >
                </el-option>
              </el-select>
            </template>
            <template slot-scope="scope">
              {{ scope.row.productName || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="考试门数">
          <el-table-column width="200">
            <template slot="header" slot-scope="scope">
              <i style="display: none">{{ scope.row }}</i>
              <el-input
                size="mini"
                v-model="countries.exampapercount"
                placeholder="输入关键字搜索"
                @input="getCountriesList()"
              />
            </template>
            <template slot-scope="scope">
              {{ scope.row.exampapercount || "--" }}
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div class="pageLocation">
        <span>已选择{{ seletedCountCountries }}条数据</span>
        <span>
          <el-pagination
            :page-sizes="[10, 20, 50, 100, 200]"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="countrieshandleSizeChange"
            @current-change="countrieshandleCurrentChange"
            :current-page="countries.pageNum"
            :total="countries.total"
            :page-size="countries.pageSize"
          >
          </el-pagination>
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="countriesPushList()">确 定</el-button>
      </span>






      
    </el-dialog>

    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
<script>
import { getActionData } from "@/utils/store";
import {
  courseManageDetail,
  dominList,
  courseTyeList,
  productSelectList,
  difficultyLevelList,
  brandList,
  authenticationList,
  industryList,
  chargeTypeList,
  matterList,
  matterTypeList,
  examList,
  recoverOrDel,
  publishApi,
  courseManageAddOrModi,
  courseAttribute,
  paperCategoryApi,
  mediaFormatList,
} from "@/service/courseListApi";
import {
    configList,     //国家认证列表
} from "@/service/examination";
import apiEnv from "@/service/apiEnv.js";
import editor from "../../components/Editor/Editor";
export default {
  components: { editor },
  data() {
    return {
      originTest: [],
      originCourse: [],
      originCountries: [],

      currentPageCourse: {},
      selectedCourse: {},

      currentTest: {},
      selectedTest: {},

      currentCountries: {},
      selectedCountries: {},
      rules: {
        courseName: [
          {
            required: true,
            message: "请输入课程名称",
            trigger: "change",
          },
        ],
        priceRequire: [
          {
            required: true,
            message: "请选择收费条件",
            trigger: ["blur", "change"],
          },
        ],
        coursePrice: [
          {
            required: true,
            message: "请输入金额",
            trigger: ["blur", "change"],
          },
          {
            pattern:
              /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "请输入有效金额",
            trigger: "blur",
          },
        ],
      },
      form: {
        spaperNo: "", //新增不用 修改用
        courseName: "",
        area: "",
        paperName: "",
        product: "",
        level: "",
        brand: "",
        certificate: "",
        industry: "",
        price: "",
        priceRequire: "",
        coursePrice: "",
        nisTop: 0,        //是否置顶
        sintro: '',       //课程介绍

        nvipIsFree: 0,    //是否免费
      },
      listMedia: [],
      listPaper: [],
      listCpimtroes: [],
      isCoursePop: false,
      isTestPop: false,
      isCountriesPop: false,
      course: {
        EffectivityTime: [],
        brandId: "",
        domin: "",
        matterType: "",
        productId: "",
        mediaNo: "",
        mediaName: "",
        mediaType: "",
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      test: {
        paperNo: "",
        name: "",
        paperName: "",
        paperCategory: "",
        field: "",
        product: "",
        brand: "",
        typeArr: [],
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
      // 国家认证
      countries: {
        id: '',         //证书号
        authname: '',   //证书名称
        domainId: '',   //领域id
        productId: '',  //产品id
        exampapercount: '', //试卷数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        authtype: 1,
        status: 1,
      },
      countriesTable:[],


      tableData2: [],
      multipleSelection: [],
      pkid: "",
      submitId: {},
      //下拉数组
      mediaFormatArr: [],
      chargeTypeArr: [],
      industryArr: [],
      authenticationArr: [],
      brandArr: [],
      difficultyLevelArr: [],
      productSelectArr: [],
      courseTypeArr: [],
      dominArr: [],
      matterTypeArr: [],
      courseAttributeArr: [],
      paperCategoryArr: [],
      url: apiEnv.uploadURL,
      testTable: [],
      //s上传
      hideUploadCover: false,
      fileListCover: [],
      dialogImageUrl: "", //封面图
      limitCount: 1,
      DialogsImageUrlCover: "",
      //e上传

      //s上传
      hideUploadDetail: false,
      fileListDetail: [],
      dialogVisible: false,
      DialogsImageUrlDetail: "", //详情图
      //e上传

      fromType: "",
      flageChangeWhList: "",
      seletedCountTest: 0,
      seletedCountCourse: 0,
      seletedCountCountries: 0,
      isPrice: false,
      lastPrice: 0,

      // 富文本编辑
      ruleText: "",
      ruleTextCache: "",

      loading:false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // vm.resetAllFun();
      if (vm.$route.query.type == 3) {
        // vm.$refs.ruleForm.resetFields();
        vm.fromType = 3;
      } else {
        vm.init();
        vm.getAllSelect();
      }
    });
  },
  beforeRouteLeave(to,from,next) {
    if(typeof(this.$route.query.pkid) != 'undefined') {
      this.resetAllFun();
      this.$refs.ruleForm.resetFields();
    }
    next()
  },
  created() {
    this.init();
    this.getAllSelect();
  },
  watch: {
    "form.priceRequire"(newVal, oldVal) {
      if (newVal == 1) {
        //eslint-disable-next-line no-debugger
        // debugger
        this.lastPrice = oldVal;
        this.form.coursePrice = 0.0;
        this.isPrice = true;
      } else {
        this.isPrice = false;
        if (this.lastPrice > 0) {
          this.form.coursePrice = this.lastPrice;
        } else {
          this.form.coursePrice = "";
        }
      }
    },
  },
  methods: {
    //富文本编辑
    // 获取富文本内容
    getEditor(value) {
      this.ruleText = value;
    },

    // 调整顺序，arr 数组，indexAdd 添加元素的位置，indexDel 删除元素的位置（indexAdd与indexDel交换位置）
    handleChangeOrder(arr, indexAdd, indexDel, type) {
      arr[indexAdd] = arr.splice(indexDel, 1, arr[indexAdd])[0];
      if (type == "course") {
        this.listMedia = arr;
        return;
      }
      if (type == "test") {
        this.listPaper = arr;
        return;
      }
      if (type == "countries") {
        this.listCpimtroes = arr;
        return;
      }
    },
    // 上移，与前一个元素交换顺序
    handleUp(index, list, type) {
      if (index - 1 >= 0) {
        this.handleChangeOrder(list, index, index - 1, type);
      } else {
        this.$message.error("素材已经置顶，无法上移！");
      }
    },
    // 下移，与后一个元素交换顺序
    handleDown(index, list, type) {
      if (index + 1 < list.length) {
        this.handleChangeOrder(list, index, index + 1, type);
      } else {
        this.$message.error("素材已经置底，无法下移");
      }
    },

    handleSelectionChangeTest(arg) {
      for (var key in this.currentTest) {
        const item = this.currentTest[key];
        if (this.selectedTest[item.spaperNo])
          delete this.selectedTest[item.spaperNo];
      }

      var count = 0;
      for (var idx in arg) {
        const item = arg[idx];
        this.selectedTest[item.spaperNo] = item;
        if (this.selectedTest[item.spaperNo]) count++;
      }
      this.seletedCountTest = count;
    },
    handleSelectionChange(arg) {
      for (var key in this.currentPageCourse) {
        const item = this.currentPageCourse[key];
        if (this.selectedCourse[item.smediaNo])
          delete this.selectedCourse[item.smediaNo];
      }

      var count = 0;
      for (var idx in arg) {
        const item = arg[idx];
        this.selectedCourse[item.smediaNo] = item;
        if (this.selectedCourse[item.smediaNo]) count++;
      }
      this.seletedCountCourse = count;
    },
    testPushList() {
      this.listPaper = this.originTest;

      var cache = this.selectedTest;
      for (var idx in this.listPaper) {
        const item = this.listPaper[idx];
        cache[item.spaperNo] = item;
      }

      var new1 = [];
      for (var key in cache) {
        const item1 = cache[key];
        new1.push(item1);
      }

      this.listPaper = new1;

      this.currentTest = {};
      this.selectedTest = {};
      this.isTestPop = false;
    },
    coursePushList() {
      this.listMedia = this.originCourse;

      var cache = this.selectedCourse;
      for (var idx in this.listMedia) {
        const item = this.listMedia[idx];
        cache[item.smediaNo] = item;
      }

      var new1 = [];
      for (var key in cache) {
        const item1 = cache[key];
        new1.push(item1);
      }

      this.listMedia = new1;

      this.currentPageCourse = {};
      this.selectedCourse = {};
      this.isCoursePop = false;
    },
    deleteTest(idx) {
      this.listPaper.splice(idx, 1);
      this.$forceUpdate();
    },
    deleteCourseItem(idx) {
      this.listMedia.splice(idx, 1);
      this.$forceUpdate();
    },
    deleteCountriesItem(idx) {
      this.listCpimtroes.splice(idx, 1);
      this.$forceUpdate();
    },
    isNumType(n) {
      var nn = Number(n);
      if (!isNaN(nn)) {
        return true;
      }
      return false;
    },
    submitForm(type) {
      const _this = this;
      _this.loading = true;
      this.$refs["ruleForm"].validate((valid) => {

        if (!valid) {
          _this.loading = false;
          return false
        }
        if (valid) {
          var submitType;
          if (type == 1) {
            submitType = 1;
          }
          if (type == 0) {
            if (this.$route.query.type == 0) {
              submitType = 1;
            }
            if (this.$route.query.type == 1) {
              submitType = 0;
            }
            if (this.$route.query.type == 3) {
              submitType = 0;
            }
          }

          var data = {
            scourseName: this.form.courseName,
            npublish: submitType,
            nsave: 1,
          };
          var arr0 = [];
          var arr1 = [];
          var arr2 = [];
          for (let i = 0; i < this.listMedia.length; i++) {
            arr0.push(this.listMedia[i].smediaNo);
          }
          //eslint-disable-next-line no-debugger
          // debugger
          if (!this.form.sintro) {
            _this.loading = false;
            return this.$message.warning("请输入课程介绍");
          }
          if (arr0.length <= 0) {
            _this.loading = false;
            this.$message.error("请选择课程素材");
            return;
          }
          for (let i = 0; i < this.listPaper.length; i++) {
            arr1.push(this.listPaper[i].spaperNo);
          }
          for (let i = 0; i < this.listCpimtroes.length; i++) {
            arr2.push(this.listCpimtroes[i].id);
          }
          if (!this.DialogsImageUrlCover) {
            _this.loading = false;
            this.$message.error("封面图未上传");
            return;
          }
          
          if(!_this.ruleText){
            _this.loading = false;
            this.$message.closeAll();
            this.$message.error("请规范详情文本文案");
            return
          }
          
          if(_this.checkVal(_this.ruleText) != ""){
            _this.loading = false;
            this.$message.closeAll();
            this.$message.error("请规范详情文本文案");
            return
          }


          data.scoverImageUrl = this.DialogsImageUrlCover;
          data.scourseDetails = this.ruleText;
          this.form.coursePrice
            ? (data.scoursePrice = this.form.coursePrice)
            : (data.scoursePrice = 0);

          if (this.$route.query.type == 3) {
            //新增
            if (arr0.length > 0) data.listMediaNo = arr0;
            if (arr1.length > 0) data.listPaperNo = arr1;
            if (arr2.length > 0) data.listAuthConfigId = arr2
            if (this.form.certificate)
              data.nauthenticationId = this.form.certificate;
            if (this.form.brand) data.nbrandId = this.form.brand;
            if (this.form.priceRequire)
              data.nchargeTypeId = this.form.priceRequire;
            if (this.form.paperName) data.ncourseTypeId = this.form.paperName;
            if (this.form.level) data.ndifficultyLevelId = this.form.level;
            if (this.form.area) data.ndomainId = this.form.area;
            if (this.form.product) data.nproductId = this.form.product;
            if (this.form.industry) data.ntradeId = this.form.industry;
            data.nisTop = this.form.nisTop
            data.sintro = this.form.sintro
            data.nvipIsFree = this.form.nvipIsFree
          }
          if (this.$route.query.type == 0 || this.$route.query.type == 1) {
            //已发布修改或者未发布修改

            data.listMediaNo = arr0.length > 0 ? arr0 : [];
            data.listPaperNo = arr1.length > 0 ? arr1 : [];
            data.listAuthConfigId = arr2.length > 0 ? arr2 : [];
            data.nauthenticationId = _this.isNumType(_this.form.certificate)
              ? _this.form.certificate
              : _this.submitId.nauthenticationId;
            data.nbrandId = _this.isNumType(_this.form.brand)
              ? _this.form.brand
              : _this.submitId.nbrandId;
            data.nchargeTypeId = _this.isNumType(_this.form.priceRequire)
              ? _this.form.priceRequire
              : _this.submitId.nchargeTypeId;
            data.ncourseTypeId = _this.isNumType(_this.form.paperName)
              ? _this.form.paperName
              : _this.submitId.ncourseTypeId;
            data.ndifficultyLevelId = _this.isNumType(_this.form.level)
              ? _this.form.level
              : _this.submitId.ndifficultyLevelId;
            data.ndomainId = _this.isNumType(_this.form.area)
              ? _this.form.area
              : _this.submitId.ndomainId;
            data.nproductId = _this.isNumType(_this.form.product)
              ? _this.form.product
              : _this.submitId.nproductId;
            data.ntradeId = _this.isNumType(_this.form.industry)
              ? _this.form.industry
              : _this.submitId.ntradeId;
            data.pkid = this.pkid;
            data.nisTop = this.form.nisTop
            data.sintro = this.form.sintro
            data.nvipIsFree = this.form.nvipIsFree
          }

          courseManageAddOrModi(data).then((r) => {
            _this.loading = false;
            if (r.Result == 1) {
              this.resetAllFun()
              if (submitType == 0) {
                this.$message.success("保存成功");
                this.$router.push(`/examination/courseList?type=1`);
              }
              if (submitType == 1) {
                this.$message.success("保存并发布成功");
                this.$router.push(`/examination/courseList?type=0`);
              }
            }
          });
        }
      });
    },
    checkVal(str)
	{
		let num = 0,
		reg = /<p>(&nbsp;|&nbsp;\s+)+<\/p>|<p>(<br>)+<\/p>/g;
		while (num < str.length && str != "")
		{
			num++;
			let k = str.match(reg);
			if (k) {
				str = str.replace(k[0], "");
			}
		}
		return str == "";
	},
    resetAllFun() {
      this.form = {
        spaperNo: "",
        courseName: "",
        area: "",
        paperName: "",
        product: "",
        level: "",
        brand: "",
        certificate: "",
        industry: "",
        price: "",
        priceRequire: "",
        coursePrice: "",
        nisTop: 0,
        sintro: "",
        nvipIsFree: 0,
      };
      this.listMedia = [];
      this.listPaper = [];
      this.listCpimtroes = [];
      this.DialogsImageUrlCover = "";
      this.DialogsImageUrlDetail = "";
      this.fileListCover = [];
      this.fileListDetail = [];
      this.hideUploadCover = false;
      this.hideUploadDetail = false;
      this.lastPrice = "";
      this.$refs["weditor"].setText("");
      this.originCourse = [];
      this.originTest = [];
      this.originCountries = [];
      this.productSelectArr = [];
      this.$refs.ruleForm.resetFields();
    },
    async pubishFuc(type) {
      var data = {
        npublish: type,
        pkid: this.pkid,
      };
      let r = await publishApi(data);
      if (r.Result == 1) {
        if (type == 0) {
          this.$message.success("取消发布成功");
          this.$router.push(`/examination/courseList?type=1`);
        }
        if (type == 1) {
          this.$message.success("发布成功");
          this.$router.push(`/examination/courseList?type=0`);
        }
      }
    },
    deleteCourse(type) {
      const _this = this;
      var tips = ''
      type == 0?tips="是否确定删除整个课程?":tips="是否恢复课程?"
      this.$confirm(tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var data = {
            nisShow: type,
            pkid: this.pkid,
          };
          recoverOrDel(data).then((r)=>{
            if (r.Result == 1) {
            _this.resetAllFun();
            if (type == 0) {
              this.$message.success("删除成功");
              this.$router.push(`/examination/courseList?type=2`);
            }
            if (type == 1) {
              this.$message.success("恢复成功");
              this.$router.push(`/examination/courseList?type=1`);
            }
          }
          })
          
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //s上传
    uploadPreview(file) {
      let _this = this;
      const isSize = new Promise(function (resolve, reject) {
        let width = 690; // 限制图片尺寸为654X270
        let height = 460;
        let _URL = window.URL || window.webkitURL;
        let img = new Image();
        img.onload = function () {
          let valid = img.width === width && img.height === height;
          valid ? resolve() : reject();
        };
        img.src = _URL.createObjectURL(file);
      }).then(
        () => {
          return file;
        },
        () => {
          _this.$message.error("图片尺寸限制为690 x 460");
          return Promise.reject();
        }
      );
      return isSize;
    },
    dealImgChangeCover(file, fileList) {
      this.hideUploadCover = fileList.length >= this.limitCount;
    },
    //删除上传文件Cover
    handleDealImgRemoveCover(file, fileList) {
      this.hideUploadCover = fileList.length >= this.limitCount;
      this.fileListCover = fileList;
      this.DialogsImageUrlCover = "";
      //eslint-disable-next-line no-debugger
      debugger;
    },
    //上传成功Cover
    handleAvatarSuccessCover(res, file, fileList) {
      if (res.Result != 1) {
        this.fileListCover = [];
        return this.$message.error(res.Message);
      }
      this.fileListCover = fileList;
      this.DialogsImageUrlCover = res.Data[0].imgUrl;
      console.log(this.DialogsImageUrlCover);
    },
    //点击图片查看
    handlePictureCardPreview(file) {
      this.dialogImageUrl = "";
      this.dialogImageUrl = file.response
        ? file.response.Data[0].imgUrl
        : file.url;
      this.dialogVisible = true;
    },
    //e上传

    //s上传
    dealImgChangeDetail(file, fileList) {
      this.hideUploadDetail = fileList.length >= this.limitCount;
    },
    //删除上传文件Detail
    handleDealImgRemoveDetail(file, fileList) {
      this.hideUploadDetail = fileList.length >= this.limitCount;
      this.fileListDetail = fileList;
      this.DialogsImageUrlDetail = "";
      //eslint-disable-next-line no-debugger
      // debugger
    },
    //上传成功Detail
    handleAvatarSuccessDetail(res, file, fileList) {
      if (res.Result != 1) {
        this.fileListDetail = [];
        return this.$message.error(res.Message);
      }
      this.fileListDetail = fileList;
      this.DialogsImageUrlDetail = res.Data[0].imgUrl;
      console.log(this.DialogsImageUrlDetail);
    },
    //e上传

    coursehandleSizeChange(val) {
      this.course.pageNum = 1;
      this.course.pageSize = val;
      this.GetMatterList();
    },
    coursehandleCurrentChange(val) {
      this.course.pageNum = val;
      this.GetMatterList();
    },
    testhandleSizeChange(val) {
      this.test.pageNum = 1;
      this.test.pageSize = val;
      this.getExamList();
    },
    testhandleCurrentChange(val) {
      this.test.pageNum = val;
      this.getExamList();
    },
    paperAttributeFun(id) {
      //1=认证考试，2=课程考试
      if (id == 1) {
        return "认证考试";
      }
      if (id == 2) {
        return "课程考试";
      }
      return "--";
    },
    paperCategoryFun(id) {
      if (id == 1) {
        return "安全规范";
      }
      if (id == 2) {
        return "能力测评";
      }
      if (id == 3) {
        return "工艺";
      }
      return "--";
    },
    clearTest() {
      this.test = {
        paperNo: "",
        name: "",
        paperName: "",
        paperCategory: "",
        field: "",
        product: "",
        brand: "",
        pageNum: 1,
        pageSize: 10,
      };
    },
    addTestBtn() {
      this.clearTest();
      for (var idx in this.listPaper) {
        const item = this.listPaper[idx];
        this.selectedTest[item.spaperNo] = item;
      }

      this.isTestPop = true;
      this.getExamList();
    },
    async getExamList() {
      const _this = this;

      var data = {
        pageNum: this.test.pageNum,
        pageSize: this.test.pageSize,
        npublishStatus: 1,
      };
      var tempArr0 = [];
      var tempArr1 = [];
      if (_this.test.paperNo) data.spaperNo = _this.test.paperNo;
      if (_this.test.name) data.spaperName = _this.test.name;
      if (_this.test.paperName) data.npaperAttribute = _this.test.paperName;
      if (_this.test.paperCategory)
        data.npaperCategory = _this.test.paperCategory;
      if (_this.test.field) {
        tempArr0.push(this.test.field);
        data.sfieldIds = tempArr0;
      }
      if (_this.test.product) {
        tempArr1.push(this.test.product);
        data.sproductIds = tempArr1;
      }
      if (_this.test.brand) data.sbrandId = _this.test.brand;
      let r = await examList(data);
      if (r.Result == 1) {
        const old = JSON.parse(JSON.stringify(this.selectedTest));
        this.currentTest = {};
        for (var idx in r.Data.datas) {
          const item = r.Data.datas[idx];
          this.currentTest[item.spaperNo] = item;
        }

        this.testTable = r.Data.datas;
        this.test.total = r.Data.total;
        this.$forceUpdate();

        if (Object.keys(old).length)
          this.$nextTick(() => {
            for (var idx1 in _this.testTable) {
              const item1 = _this.testTable[idx1];
              if (old[item1.spaperNo]) {
                _this.$refs.testTable.toggleRowSelection(item1);
              }
            }

            for (var key1 in old) {
              const item2 = old[key1];
              _this.selectedTest[key1] = item2;
            }

            this.$forceUpdate();
          });
      }
    },
    getProductAndList(id, type) {
      this.flageChangeWhList = type;

      this.$nextTick(() => {
        this.getProductSelectList(id);
      });
    },
    clearCourse() {
      this.course = {
        mediaNo: "",
        mediaName: "",
        mediaType: "",
        matterType: "",
        domin: "",
        productId: "",
        brandId: "",
        pageNum: 1,
        pageSize: 10,
      };
    },
    addCourseBtn() {
      this.clearCourse();

      for (var idx in this.listMedia) {
        const item = this.listMedia[idx];
        this.selectedCourse[item.smediaNo] = item;
      }

      this.GetMatterList();
      this.isCoursePop = true;
    },

    async GetMatterList() {
      const _this = this;

      this.listLoading = true;
      var data = {
        pageNum: this.course.pageNum,
        pageSize: this.course.pageSize,
        rational: false,
      };
      if (
        this.course.EffectivityTime instanceof Array &&
        this.course.EffectivityTime.length > 0
      ) {
        data.dupdateDateBegin = this.course.EffectivityTime[0] + " 00:00:00";
        data.dupdateDateEnd = this.course.EffectivityTime[1] + " 23:59:59";
      } else {
        if (data.dupdateDateBegin) delete data.dupdateDateBegin;
        if (data.dupdateDateEnd) delete data.dupdateDateEnd;
      }
      if (this.course.brandId) data.nbrandId = this.course.brandId;
      if (this.course.domin) data.ndomainId = this.course.domin;
      if (this.course.matterType) data.nmediaTypeId = this.course.matterType;
      if (this.course.productId) data.nproductId = this.course.productId;
      if (this.course.mediaNo) data.smediaNo = this.course.mediaNo;
      if (this.course.mediaName) data.smediaName = this.course.mediaName;
      if (this.course.mediaType) data.nmediaFormatId = this.course.mediaType;

      let res = await matterList(data);
      this.listLoading = false;
      if (res.Result != 1) {
        return this.$message.error("获取失败请联系开发人员");
      }

      const old = JSON.parse(JSON.stringify(_this.selectedCourse));
      this.currentPageCourse = {};
      for (var idx in res.Data.datas) {
        const item = res.Data.datas[idx];
        this.currentPageCourse[item.smediaNo] = item;
      }

      this.tableData2 = res.Data.datas;
      this.course.total = res.Data.total;
      this.$forceUpdate();

      if (Object.keys(old).length)
        this.$nextTick(() => {
          for (var idx1 in _this.tableData2) {
            const item1 = _this.tableData2[idx1];
            if (old[item1.smediaNo]) {
              _this.$refs.courseTable.toggleRowSelection(item1);
            }
          }

          for (var key1 in old) {
            const item2 = old[key1];
            _this.selectedCourse[key1] = item2;
          }

          this.$forceUpdate();
        });
    },

    getAllSelect() {
      this.getChargeTypeList();
      this.getIndustryList();
      this.getAuthenticationList();
      this.getBrandList();
      this.getDifficultyLevelList();
      this.getProductSelectList();
      this.getCourseTypeList();
      this.getDominList();
      this.getMatterType();
      this.getCourseAttribute();
      this.paperCategoryApiFun();
      this.getMediaFormatList();
    },

    getMediaFormatList() {
      mediaFormatList().then((r) => {
        if (r.Result == 1) {
          this.mediaFormatArr = r.Data || [];
        }
      });
    },
    paperCategoryApiFun() {
      paperCategoryApi().then((r) => {
        if (r.Result == 1) {
          this.paperCategoryArr = r.Data || [];
        }
      });
    },
    getCourseAttribute() {
      courseAttribute().then((r) => {
        if (r.Result == 1) {
          this.courseAttributeArr = r.Data || [];
        }
      });
    },
    getMatterType() {
      matterTypeList().then((r) => {
        if (r.Result == 1) {
          this.matterTypeArr = r.Data || [];
        }
      });
    },
    getChargeTypeList() {
      chargeTypeList().then((r) => {
        if (r.Result == 1) {
          this.chargeTypeArr = r.Data || [];
        }
      });
    },
    getIndustryList() {
      industryList().then((r) => {
        if (r.Result == 1) {
          this.industryArr = r.Data || [];
        }
      });
    },
    getAuthenticationList() {
      authenticationList().then((r) => {
        if (r.Result == 1) {
          this.authenticationArr = r.Data || [];
        }
      });
    },
    getBrandList() {
      brandList().then((r) => {
        if (r.Result == 1) {
          this.brandArr = r.Data || [];
        }
      });
    },

    getDifficultyLevelList() {
      difficultyLevelList().then((r) => {
        if (r.Result == 1) {
          this.difficultyLevelArr = r.Data || [];
        }
      });
    },
    getProductSelectList(id) {
      const _this = this;
      productSelectList(id).then((r) => {
        if (r.Result == 1) {
          _this.productSelectArr = r.Data || [];
          _this.$forceUpdate();
          if (this.flageChangeWhList == "mainForm") {
            _this.form.product = "";
            return;
          }
          if (this.flageChangeWhList == "test") {
            _this.test.product = "";
            this.getExamList();
            return;
          }
          if (this.flageChangeWhList == "course") {
            _this.course.productId = "";
            this.GetMatterList();
            return;
          }
          if (this.flageChangeWhList == "countries") {
            _this.countries.productId = "";
            this.getCountriesList();
            return;
          }
        }
      });
    },
    getCourseTypeList() {
      courseTyeList().then((r) => {
        if (r.Result == 1) {
          this.courseTypeArr = r.Data || [];
        }
      });
    },
    getDominList() {
      dominList().then((r) => {
        if (r.Result == 1) {
          this.dominArr = r.Data || [];
        }
      });
    },
    init() {
      this.fromType = this.$route.query.type;
      this.pkid = this.$route.query.pkid;
      if (this.pkid) {
        this.getDetail();
      }
    },
    getDetail() {
      const _this = this;
      var data = {
        pkid: this.pkid,
      };
      courseManageDetail(data).then((r) => {
        var d = r.Data;
        console.log(d)
        if (r.Result == 1) {
          this.form = {
            courseName: d.scourseName,
            area: d.sdomain,
            paperName: d.scourseType,
            product: d.sproduct,
            level: d.sdifficultyLevel,
            brand: d.sbrand,
            certificate: d.sauthentication,
            industry: d.strade,
            priceRequire: d.schargeType,
            coursePrice: d.scoursePrice,
            nisTop: d.nisTop || 0,
            sintro: d.sintro,
            nvipIsFree: d.nvipIsFree || 0,
          };
          console.log('-----------------',this.form)

          //eslint-disable-next-line no-debugger
          // debugger
          this.submitId = {
            nauthenticationId: d.nauthenticationId,
            nbrandId: d.nbrandId,
            nchargeTypeId: d.nchargeTypeId,
            ncourseTypeId: d.ncourseTypeId,
            ndifficultyLevelId: d.ndifficultyLevelId,
            ndomainId: d.ndomainId,
            nproductId: d.nproductId,
            ntradeId: d.ntradeId,
            scoverImageUrl: d.scoverImageUrl,
            sdetailsImageUrl: d.sdetailsImageUrl,
          };
          this.listMedia = d.listMedia;
          this.listPaper = d.listPaper;
          this.listCpimtroes = d.listAuthConfig


          this.originTest = d.listPaper;
          this.originCourse = d.listMedia;
          this.originCountries = d.listAuthConfig;
          

          let objCover = {};
          let objDetail = {};
          this.fileListCover = [];
          this.fileListDetail = [];
          if (d.scoverImageUrl) {
            objCover.url = d.scoverImageUrl;
            this.fileListCover.push(objCover);
            this.hideUploadCover = true;
            this.DialogsImageUrlCover = d.scoverImageUrl;
          }
          if (d.sdetailsImageUrl) {
            objDetail.url = d.sdetailsImageUrl;
            this.fileListDetail.push(objDetail);
            this.hideUploadDetail = true;
            this.DialogsImageUrlDetail = d.sdetailsImageUrl;
          }
          if (d.scourseDetails)
            this.$refs["weditor"].setText("<p>" + d.scourseDetails + "</p>");
          _this.$nextTick(() => {
            _this.form.coursePrice = d.scoursePrice;
            if (_this.form.coursePrice == 0) {
              _this.isPrice = true;
            }
          });
        }
      });
    },
    handleCloseCourse() {
      this.currentPageCourse = {};
      this.selectedCourse = {};
      this.isCoursePop = false;
    },
    handleCloseTest() {
      this.currentTest = {};
      this.selectedTest = {};

      this.isTestPop = false;
    },

    // 国家认证
    clearCountries() {
      this.countries = {
        id: '',         //证书号
        authname: '',   //证书名称
        domainId: '',   //领域id
        productId: '',  //产品id
        exampapercount: '',   //试卷数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        authtype: 1,
        status: 1,
      };
    },
    addCountriesBtn(){
      this.clearCountries();
      for (var idx in this.listCpimtroes) {
        const item = this.listCpimtroes[idx];
        this.selectedCountries[item.id] = item;
      }
      this.isCountriesPop = true;
      this.getCountriesList();
    },

    // 多选
    handleSelectionChangeCountries(arg){
      for (var key in this.currentCountries) {
        const item = this.currentCountries[key];
        if (this.selectedCountries[item.id])
          delete this.selectedCountries[item.id];
      }

      var count = 0;
      for (var idx in arg) {
        const item = arg[idx];
        this.selectedCountries[item.id] = item;
        if (this.selectedCountries[item.id]) count++;
      }
      this.seletedCountCountries = count
    },
    // 分页
    countrieshandleSizeChange(val) {
      this.countries.pageNum = 1;
      this.countries.pageSize = val;
      this.getCountriesList();
    },
    countrieshandleCurrentChange(val) {
      this.countries.pageNum = val;
      this.getCountriesList();
    },
    async getCountriesList(){
      const _this = this;
      var data = {
        pageNum: this.countries.pageNum,
        pageSize: this.countries.pageSize,
        authtype: this.countries.authtype,
        status: this.countries.status,
      }
      if (_this.countries.id) data.id = _this.countries.id;
      if (_this.countries.authname) data.authname = _this.countries.authname;
      if (_this.countries.domainId) data.domainId = _this.countries.domainId;
      if (_this.countries.productId) data.productId = _this.countries.productId;
      if (_this.countries.exampapercount) data.exampapercount = _this.countries.exampapercount;
      let r = await configList(data)
      if(r.Result ==1) {
        const old = JSON.parse(JSON.stringify(this.selectedCountries));
        this.currentCountries = {};
        for (var idx in r.Data.datas) {
          const item = r.Data.datas[idx];
          this.currentCountries[item.id] = item;
        }
        this.countriesTable = r.Data.datas;
        this.countries.total = r.Data.total;
        this.$forceUpdate();

        if (Object.keys(old).length)
          this.$nextTick(() => {
            for (var idx1 in _this.countriesTable) {
              const item1 = _this.countriesTable[idx1];
              if (old[item1.id]) {
                _this.$refs.countriesTable.toggleRowSelection(item1);
              }
            }

            for (var key1 in old) {
              const item2 = old[key1];
              _this.selectedCountries[key1] = item2;
            }
            this.$forceUpdate();
          });

      }
    },
    countriesPushList(){
      this.listCpimtroes = this.originCountries;
      var cache = this.selectedCountries;
      for (var idx in this.listCpimtroes) {
        const item = this.listCpimtroes[idx];
        cache[item.id] = item;
      }

      var new1 = [];
      for (var key in cache) {
        const item1 = cache[key];
        new1.push(item1);
      }

      this.listCpimtroes = new1;
      console.log('aaaaaaaaaaaaaaaa',this.listCpimtroes)
      this.currentCountries = {};
      this.selectedCountries = {};
      this.isCountriesPop = false;
    },


















    handleCloseCountries(){
      this.currentCountries = {}
      this.selectedCountries = {},

      this.isCountriesPop = false
    },
  },
};
</script>
<style lang="scss">
.title-box {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: bottom;

  .detail-title {
    padding: 0 20px;
    height: 40px;
    border-top: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    text-align: center;
    line-height: 40px;
    color: #409EFF;
    font-size: 14px;
  }

  .save-box {
    display: flex;
    width: calc(100% - 98px);
    flex-direction: row;
    justify-content: flex-end;
    border-bottom: 1px solid #e5e5e5;
    align-items: flex-end;
    height: 40px;
    .publish {
      width: 100px;
      height: 30px;
      line-height: 30px;
      padding: 0;
      margin-bottom: 12px;
    }

    .save {
      width: 100px;
      height: 30px;
      line-height: 30px;
      padding: 0;
      margin-bottom: 12px;
    }
  }
}

.commonTitle {
  height: 48px;
  background-color: #f9f9f9;
  border: solid 1px #e5e5e5;
  font-size: 16px;
  color: #111111;
  line-height: 48px;
  margin: 32px 0 19px;
  padding-left: 23px;
}

.commonTitleIcon::before {
  content: "*";
  font-size: 12px;
  color: #f56c6c;
  display: inline-block;
}

.one-ruleForm {
  position: relative;

  .next-button {
    position: absolute;
    right: 0;
    top: -70px;
  }

  > .el-form-item {
    margin-bottom: 30px !important;
  }
}

.tableBox {
  width: 97%;
  margin: 0 auto;
}

.addCourse {
  height: 38px;
  border: solid 1px #e5e5e5;
  text-align: center;
  line-height: 38px;
  font-size: 14px;
  color: #f75959;
  border-top: none;
  cursor: pointer;
}

.uploadBox {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-items: flex-start;
  margin-bottom: 15px;

  .upload1 {
    width: 50%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;

    .tit::before {
      content: "*";
      color: #ff0000;
    }

    .tit {
      min-width: 86px;
      margin-right: 55px;
      color: #666666;
      font-size: 16px;
    }

    .tips {
      margin-top: 15px;
      font-size: 14px;
      color: #999999;
      display: block;
    }
  }
}

.detailImg {
  margin-top: 40px;
  padding-bottom: 150px;
  display: flex;
  flex-direction: row;
  .tit {
    min-width: 86px;
    margin-right: 50px;
  }
  .tit::before {
    content: "*";
    color: #ff0000;
  }
}

.pageLocation {
  position: absolute;
  left: 10px;
  bottom: 22px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.hide .el-upload--picture-card {
  display: none;
}
</style>